import {Grid} from '@logistics-frontend/blocks'
import {noop} from '@logistics-frontend/utils'
import React from 'react'

type TProps = React.PropsWithChildren<{
  classes?: string
  onChange?: (e?: React.PointerEvent<HTMLButtonElement>, expanded?: boolean) => void
}>

type TAccordionContext = {
  expanded: boolean
  toggle: () => void
}

const AccordionContext = React.createContext<TAccordionContext>({
  expanded: false,
  toggle: noop,
})

export const Accordion: React.FC<TProps> = ({children, classes: classesProp}) => {
  const [expanded, setExpanded] = React.useState(false)

  const toggle = React.useCallback(() => {
    setExpanded(!expanded)
  }, [expanded])

  const ctx = React.useMemo<TAccordionContext>(() => ({expanded, toggle}), [expanded, toggle])

  return (
    <Grid
      alignItems="flex-start"
      className={classesProp}
      component="section"
      direction="column"
      wrap="nowrap"
      container
    >
      <AccordionContext.Provider value={ctx}>{children}</AccordionContext.Provider>
    </Grid>
  )
}

export function useAccordion() {
  const context = React.useContext(AccordionContext)
  return context
}
